export const DATE_FORMAT = 'yyyy-MM-dd';

export const PAGE_SIZE = 10;

export const GENERAL_PRACTICE = 'General Practice';

export const PSYCHOLOGY = 'Psychology';

/** animation duration for dropdown filters, drawers and the shade view */
export const OVERLAY_ANIMATION_DURATION = 400;

export const FLAGR_MAP_SEARCH = 'ky13c1vozch91wgku';
